import { Injectable, Input } from '@angular/core';
import {
  API_METHODS,
  API_URL,
  OperationType,
} from 'common/constants/sm-constants';
import { environment } from 'src/environments/environment';
import { TrainersModel } from 'common/models/page-models/Trainers Model/trainers-data.model';
import { FormDataService } from '../../base-data-services/form-data.service';
import { SmApiService } from 'common/services/core-services/sm-api.service';
import { SystemService } from 'common/services/core-services/system.service';

@Injectable({
  providedIn: 'root',
})
export class TrainersFormDataService extends FormDataService<TrainersModel> {
  // @Input() override pageData: any = {};

  constructor(http: SmApiService, protected override ss: SystemService) {
    super(API_URL.trainersAdd, http, ss);
  }

  override getEditUrlAndMethod() {
    const edit = {
      url: environment.apiUrl + API_URL.trainersEdit,
      method: API_METHODS.post,
    };
    return edit;
  }

  override afterGetData(model: any): Promise<TrainersModel> {
    return new Promise<any>((resolve, reject) => {
      model.id = model.user_id;
      // console.log(model);
      if (model.category_name && Array.isArray(model.category_name)) {
        model['categoryIds'] = model.category_name.map(
          (category: any) => category.id
        );
      } else {
        model['categoryIds'] = [];
      }
      resolve(model);
    });
  }

  override beforePostData(
    model: any,
    metamodel: any,
    dataModel: any
  ): Promise<TrainersModel> {
    return new Promise<any>((resolve, reject) => {
      // console.log(model);
  
      // Remove unwanted fields
      delete model.user_id;
      delete model.category_name;
  
      // Remove `id` if it's empty
      if (model.id === '') {
        delete model.id;
      }
  
      resolve(model);
    });
  }
  
  override getOperationType(
    data: any
  ): OperationType.CREATE | OperationType.UPDATE {
    if (data.hasOwnProperty('id')) {
      return data.id !== '' ? OperationType.UPDATE : OperationType.CREATE;
    } else {
      return OperationType.CREATE;
    }
  }
  override getUpdateUrl() {
    return API_URL.trainersUpdates;
  }

  createInstance(): TrainersModel {
    return new TrainersModel();
  }
}

export { FormDataService };
